import LoggedInUser from './LoggedInUser'
import Helpers from './Helpers';

export function jobs({ page, scope, perPage, status } = {}) {
    const paramsObj = { status, per_page: perPage, scope, page, auth_token: LoggedInUser.getInfo().auth_token };
    Object.keys(paramsObj).forEach((k) => { if (!paramsObj[k]) delete paramsObj[k] })
    const searchParams = new URLSearchParams(paramsObj);

    return fetch(Helpers.endpoint(`/jobs/?${searchParams.toString()}`), {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((response) => response.json())
}

export function unexpirableJobs(){
    return fetch(Helpers.endpoint("/unexpirable_jobs/?auth_token=" + LoggedInUser.getInfo().auth_token), {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((response) => response.json())
}


export function job(job_swipecast_id) {
    return fetch(Helpers.endpoint("/job/" + job_swipecast_id + "?auth_token=" + LoggedInUser.getInfo().auth_token), {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }).then((response) => response.json())

}
